import React from 'react';

import { Button, IconCard } from '@project/components';
import { CommunicationMethodEnum } from '@project/enums/communication-method.enum';

export const CommunicationMethodForm = ({
  submitForm,
  selectedMethod,
  setSelectedMethod,
  isSubmitting,
}) => {
  const handleMethodSelection = (method) => {
    setSelectedMethod(method);
  };

  const getCardClassName = (method) => {
    const baseClass = 'w-3/5 transition-colors relative';

    switch (method) {
      case CommunicationMethodEnum.email:
        return `${baseClass} ${
          selectedMethod === method
            ? 'bg-secondary ring-4 ring-offset-2 ring-white/50'
            : 'bg-secondary-dark hover:bg-secondary'
        }`;
      case CommunicationMethodEnum.phone:
        return `${baseClass} ${
          selectedMethod === method
            ? 'bg-primary ring-4 ring-offset-2 ring-white/50'
            : 'bg-primary-dark hover:bg-primary'
        }`;
      case CommunicationMethodEnum.both:
        return `${baseClass} ${
          selectedMethod === method
            ? 'bg-tertiary ring-4 ring-offset-2 ring-white/50'
            : 'bg-tertiary-dark hover:bg-tertiary'
        }`;
      default:
        return baseClass;
    }
  };

  const getSelectedMethodText = () => {
    if (selectedMethod === 0 || selectedMethod === CommunicationMethodEnum.email) {
      return 'Email Only';
    }
    if (selectedMethod === 1 || selectedMethod === CommunicationMethodEnum.phone) {
      return 'Phone Only';
    }
    if (selectedMethod === 2 || selectedMethod === CommunicationMethodEnum.both) {
      return 'Email and Phone';
    }
    return String(selectedMethod);
  };

  return (
    <div className="flex gap-4 my-4 w-full justify-center items-center flex-col flex-1">
      <p className="text-text-grey text-xl">Communication Preference</p>
      <p className="text-text-grey text-base mb-2">How would you like us to contact you?</p>

      <IconCard
        icon={<img src="assets/icons/mail-icon.png" alt="email" />}
        text="Email Only"
        onClick={() => handleMethodSelection(CommunicationMethodEnum.email)}
        className={getCardClassName(CommunicationMethodEnum.email)}
      />

      <IconCard
        icon={<img src="assets/icons/phone-icon.png" alt="phone" />}
        text="Phone Only"
        onClick={() => handleMethodSelection(CommunicationMethodEnum.phone)}
        className={getCardClassName(CommunicationMethodEnum.phone)}
      />

      <IconCard
        icon={<img src="assets/icons/plus-icon.png" alt="both" />}
        text="Email and Phone"
        onClick={() => handleMethodSelection(CommunicationMethodEnum.both)}
        className={getCardClassName(CommunicationMethodEnum.both)}
      />

      {selectedMethod !== undefined && selectedMethod !== null && (
        <div className="mt-2 text-center text-sm text-gray-600">
          Selected: <span className="font-semibold">{getSelectedMethodText()}</span>
        </div>
      )}

      <Button
        onClick={() => submitForm()}
        className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        disabled={selectedMethod === undefined || selectedMethod === null}
        isLoading={isSubmitting}
      >
        Continue
      </Button>
    </div>
  );
};
